import {Component} from "@angular/core";

@Component({
    selector: "fui-fragment",
    styleUrls: ["./fragment.component.scss"],
    templateUrl: "./fragment.component.html"
})
export class FUIFragmentComponent {
}
